angular
  .module("AccountingBoxApp")
  .controller("FileViewerCtrl", function(
      $scope,
      $rootScope,
      $http,
    LoopBackAuth,
    Attachment,
    $state
  ) {
    $scope.pdf = function() {
      if (!$scope.attachment) {
        return false;
      }
      var e = $scope.attachment.name.split(".").pop();
      e = e.toLowerCase();
      return e === "pdf";
    };

    window.addEventListener("message", receiveMessage, false);
    $scope.$on('$destroy', function() {
      window.removeEventListener("message", receiveMessage, false);
    });
    function receiveMessage(event) {
      if (event.origin !== window.origin) return;
      if (event.data.source !== 'pdf-viewer') return;
      if (event.data.type !== 'DOWNLOAD_FILE') return;
      var url = event.data.url;
      if(url) {
        url = url.replace('format=annotated', 'format=original');
      }
      $scope.download(url);
    }


    $scope.download = function(url) {
      if(!url) {
        url =$scope.getAttachmentUrl($scope.attachment.id,'original')
      }
      var x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = 'blob';
      x.onload=function(e) {
        var blob = new Blob([x.response]);
        var fileName = $scope.attachment.name;
        $rootScope.download(blob, fileName);
      };
     x.send();
    };

    $scope.getAttachmentUrl = $scope.$root.getAttachmentUrl;
    $scope.getAttachmentPdfUrl = function(attachmentId) {
      return encodeURIComponent(
        $scope.getAttachmentUrl(attachmentId, "annotated")
      );
    };

    $scope.rotation = 0;
    $scope.rotate = function() {
      $scope.rotation += 90;

      var deg = $scope.rotation;
      $("#preview-image").css({
        "-webkit-transform": "rotate(" + deg + "deg)", //Safari 3.1+, Chrome
        "-moz-transform": "rotate(" + deg + "deg)", //Firefox 3.5-15
        "-ms-transform": "rotate(" + deg + "deg)", //IE9+
        "-o-transform": "rotate(" + deg + "deg)", //Opera 10.5-12.00
        transform: "rotate(" + deg + "deg)" //Firefox 16+, Opera 12.50+
      });
    };
    $scope.token = LoopBackAuth.accessTokenId;
    $scope.apiEndpoint = API_ENDPOINT;
    $scope.isNew = function() {
      if ($state.current.name.indexOf("app.company.new") > -1) {
        return true;
      } else {
        return false;
      }
    };
    $scope.isBookkeeper = $scope.$root.isBookkeeper;

    $scope.removeModal = function() {
      $("#removeAttachmentModalFileView").appendTo("#app-content");
      $("#removeAttachmentModalFileView").modal("show");
    };

    $scope.removeAttachment = function(attachment) {
      $("#removeAttachmentModalFileView").modal("hide");
      Attachment.deleteById({
        id: attachment.id
      }).$promise.then(function() {
        console.log("deleted attachment app.company.inbox before");
        $state.go("app.company.inbox");
        console.log("deleted attachment app.company.inbox after");
        $('.modal-backdrop.fade.in').remove();
      });
    };
    /*$scope.downloadUrl = function (attachmentId) {
           var url = API_ENDPOINT+'/Attachments/'+attachmentId+'/download?format=original'+'&access_token='+LoopBackAuth.accessTokenId;
           return url;
       //	window.location.assign(url);
           //Attachment.download({id:attachmentid});
       };*/
  });
